
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/purchaseOrders',
    meta: { title: '采购订单' },
    component: Layout,
    redirect: '/purchaseOrders/list',
    children: [
      {
        path: 'list',
        meta: { title: '采购订单', activeMenu: '/purchaseOrders' },
        component: () => import('@/views/purchaseOrders/PurchaseOrders.vue')
      },
      {
        path: 'detail',
        meta: { title: '采购订单详情', activeMenu: '/purchaseOrders' },
        component: () => import('@/views/purchaseOrders/PurchaseOrdersDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑采购订单', activeMenu: '/purchaseOrders' },
        component: () => import('@/views/purchaseOrders/PurchaseOrdersAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增采购订单', activeMenu: '/purchaseOrders' },
        component: () => import('@/views/purchaseOrders/PurchaseOrdersAdd.vue')
      }

    ]
  }

]
